import { CountryDto } from './country.dto';
import { CurrencyDto } from './currency.dto';

export enum EAccountBankType {
  BankAccount = 'BankAccount',
  SenderAccount = 'SenderAccount',
  ReceiverAccount = 'ReceiverAccount',
}

export class ContactAccountDto {
  id?: number;
  country?: CountryDto;
  countryId?: number;
  currency?: CurrencyDto;
  currencyId?: number;
  city?: string;
  account?: string;
  name?: string;
  swift?: string;
  number?: string;
  aba?: string;
  iban?: string;
  code?: string;
  agency?: string;
  bank?: string;
  institutionNumber?: string;
  transit?: string;
  address?: string;
  cbu?: string;
  cable?: string;
  blz?: string;
  cuit?: string;
  bsb?: string;
  sortCode?: string;
  fcc?: string;
  isDefault?: boolean;
  type?: EAccountBankType;
  senderReceiverName?: string;
  email?: string;
}
